export class Utils {

    public static Lerp(start, end, amt) {
        return (1 - amt) * start + amt * end
    }

    public static Interpolate(input: number, inputMin: number, inputMax: number, outputMin: number = 0, outputMax: number = 1): number {
        var value = outputMin + (((input - inputMin) * (outputMax - outputMin)) / (inputMax - inputMin));
        return value;
    }

}


export interface IGameConfig {
    highScore: number;
    // tutorial: boolean;
}

export const GameConfig: IGameConfig = {
    highScore: 0,
    // tutorial: true,
}